import styled from 'styled-components';
import { device } from 'commons';

export const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;

  @media (max-width: ${device.desktop}px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: ${device.tablet}px) {
    grid-template-columns: 1fr;
  }
`;
